// Package Imports
import Login  from "./pages/login.js"; 

// CSS Imports
import './styles/App.css';

function App() {
  return (
    <div id="app-container">
      <Login />
    </div>
  );
}


export default App;
